/* Oddsmakers — theme scripts */
(function () {
  'use strict';

  function once(el) {
    if (!el || el.hasAttribute('data-od-init')) return false;
    el.setAttribute('data-od-init', '');
    return true;
  }

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (!format) return '$' + value;
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ---------- product page ---------- */

  function initProduct(root) {
    if (!once(root)) return;
    var dataEl = root.querySelector('[data-od-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var moneyFormat = root.getAttribute('data-money-format') || '';
    var idInput = root.querySelector('[data-od-variant-id]');
    var priceEl = root.querySelector('[data-od-price]');
    var compareEl = root.querySelector('[data-od-compare-price]');
    var submitEl = root.querySelector('[data-od-submit]');
    var skuEl = root.querySelector('[data-od-sku]');
    var mainImage = root.querySelector('[data-od-main-image]');
    var inputs = root.querySelectorAll('[data-od-option-input]');
    if (!inputs.length) return;

    function selectedOptions() {
      var values = [];
      root.querySelectorAll('[data-od-option-group]').forEach(function (group) {
        var checked = group.querySelector('[data-od-option-input]:checked');
        values.push(checked ? checked.value : null);
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function update() {
      var variant = findVariant(selectedOptions());

      if (!variant) {
        if (submitEl) {
          submitEl.disabled = true;
          submitEl.textContent = submitEl.getAttribute('data-unavailable-text') || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) priceEl.textContent = money(variant.price, moneyFormat);

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (skuEl) skuEl.textContent = variant.sku || '';

      if (submitEl) {
        submitEl.disabled = !variant.available;
        submitEl.textContent = variant.available
          ? submitEl.getAttribute('data-add-text') || 'Add to cart'
          : submitEl.getAttribute('data-soldout-text') || 'Sold out';
      }

      /* keep the "Color: X" readout above the picker in step with the swatch */
      var colorOut = root.querySelector('[data-od-color-name]');
      if (colorOut) {
        root.querySelectorAll('[data-od-option-group]').forEach(function (group) {
          var legend = group.querySelector('.od-opt__label');
          if (!legend) return;
          var name = (legend.textContent || '').toLowerCase();
          if (name.indexOf('colour') === -1 && name.indexOf('color') === -1) return;
          var picked = group.querySelector('[data-od-option-input]:checked');
          if (picked) colorOut.textContent = picked.value;
        });
      }

      if (mainImage && variant.featured_image && variant.featured_image.src) {
        if (typeof root.__odShowImage === 'function') root.__odShowImage();
        mainImage.src = variant.featured_image.src;
        mainImage.srcset = '';
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', update);
    });

    update();
  }

  /* ---------- product gallery thumbnails ---------- */

  function galleryFullscreen(panel, video) {
    var showing = document.fullscreenElement || document.webkitFullscreenElement ||
                  video.webkitDisplayingFullscreen;

    if (showing) {
      try {
        if (video.webkitDisplayingFullscreen && video.webkitExitFullscreen) {
          video.webkitExitFullscreen();
          return;
        }
        var ex = document.exitFullscreen || document.webkitExitFullscreen;
        if (ex) {
          var xp = ex.call(document);
          if (xp && xp.catch) xp.catch(function () {});
        }
      } catch (e) {}
      return;
    }

    // the video itself first, so its controls come with it
    try {
      if (video.webkitEnterFullscreen) { video.webkitEnterFullscreen(); return; }
      var vr = video.requestFullscreen || video.webkitRequestFullscreen;
      if (vr) {
        var vp = vr.call(video);
        if (vp && vp.catch) vp.catch(function () { panelFullscreen(panel); });
        return;
      }
    } catch (e) {}

    panelFullscreen(panel);
  }

  function panelFullscreen(panel) {
    var pr = panel.requestFullscreen || panel.webkitRequestFullscreen;
    if (!pr) return;
    try {
      var pp = pr.call(panel);
      if (pp && pp.catch) pp.catch(function () {});
    } catch (e) {}
  }

  function initGallery(root) {
    var main = root.querySelector('[data-od-main-image]');
    var panels = root.querySelectorAll('[data-od-gal-media]');
    if (!main && !panels.length) return;

    /* Stop whatever is playing in a panel we are leaving. A paused <video> is
       enough; an embedded iframe keeps going unless its src is taken away, so
       it is parked and restored on the way back in. */
    function quiet(panel) {
      var v = panel.querySelector('video');
      if (v) { try { v.pause(); } catch (e) {} }
      var f = panel.querySelector('iframe');
      if (f && f.src) {
        f.setAttribute('data-od-src', f.src);
        f.removeAttribute('src');
      }
    }
    function wake(panel) {
      var f = panel.querySelector('iframe');
      var parked = f && f.getAttribute('data-od-src');
      if (f && parked && !f.src) f.src = parked;

      /* A <video> that was display:none for the whole page load has never been
         laid out, and several browsers will not attach its sources until it
         has been. That is the "poster shows, play does nothing" case: the
         element is there, the controls are there, and there is no media behind
         them. One load() on first reveal fixes it. Guarded so returning to the
         video later does not rewind it. */
      var v = panel.querySelector('video');
      if (v && !v.hasAttribute('data-od-loaded')) {
        v.setAttribute('data-od-loaded', '1');
        try { v.load(); } catch (e) {}
      }
    }

    function showImage() {
      if (main) main.hidden = false;
      panels.forEach(function (p) { quiet(p); p.hidden = true; });
    }
    root.__odShowImage = showImage;   // variant changes call this

    /* Two audio tracks at once is nobody's idea of premium: when a product
       video starts, the song steps aside. It is not resumed automatically -
       the visitor chose the video. */
    panels.forEach(function (panel) {
      var v = panel.querySelector('video');
      if (!v || !once(v)) return;

      /* Tapping the frame plays or pauses, which is what people expect from a
         video and is a much bigger target on a phone than the control bar. */
      v.addEventListener('click', function () {
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });

      /* Double-click fills the screen, the desktop convention. The video
         element is asked rather than its container, because the native control
         bar travels with the video into fullscreen and because iPhone Safari
         has no element fullscreen at all - only webkitEnterFullscreen on a
         video. Every route is guarded: a rejected promise here is what "the
         fullscreen button does nothing" looks like from the outside. */
      v.addEventListener('dblclick', function (e) {
        e.preventDefault();
        galleryFullscreen(panel, v);
      });

      v.addEventListener('play', function () {
        var song = document.querySelector('[data-od-song-el]');
        if (song && !song.paused) { try { song.pause(); } catch (e) {} }
      });
    });

    /* Two cases where the video has to reveal itself, because the customer has
       no way to ask for it:

         - the product has no photograph at all, so the stage would be empty
         - the product's only media IS the video, so no thumbnail row renders
           (the row needs two or more items) and there is nothing to click

       In both, show the video rather than a poster nobody can get past. */
    var thumbCount = root.querySelectorAll('[data-od-thumb]').length;
    if (panels.length && (!main || thumbCount === 0)) {
      if (main) main.hidden = true;
      panels[0].hidden = false;
      wake(panels[0]);
    }

    root.querySelectorAll('[data-od-thumb]').forEach(function (thumb) {
      if (!once(thumb)) return;
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-od-media-id');

        if (mediaId) {
          if (main) main.hidden = true;
          panels.forEach(function (p) {
            var match = p.getAttribute('data-od-gal-media') === mediaId;
            if (match) { p.hidden = false; wake(p); }
            else { quiet(p); p.hidden = true; }
          });
        } else {
          var src = thumb.getAttribute('data-full-src');
          if (!src) return;
          showImage();
          main.src = src;
          main.srcset = '';
        }

        root.querySelectorAll('[data-od-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
      });
    });
  }

  /* ---------- quantity steppers ---------- */

  function initQuantity() {
    document.querySelectorAll('[data-od-qty]').forEach(function (wrap) {
      if (!once(wrap)) return;
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-od-qty-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = parseInt(button.getAttribute('data-od-qty-step'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- policy overlays ----------
     The footer links stay real links: with JavaScript off, or if the overlay is
     ever missing, the browser simply follows the href. When the overlay exists
     we intercept and show the text in place instead. */

  var policyReady = false;
  function initPolicy() {
    if (policyReady) return;
    if (!document.querySelector('[data-od-policy]')) return;
    policyReady = true;
    var last = null;

    function open(id) {
      var box = document.getElementById(id);
      if (!box) return false;
      last = document.activeElement;
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      var x = box.querySelector('[data-od-policy-close]');
      if (x && x.focus) x.focus();
      return true;
    }
    function close() {
      document.querySelectorAll('[data-od-policy]').forEach(function (b) { b.hidden = true; });
      document.body.style.overflow = '';
      if (last && last.focus) last.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-od-policy-open]') : null;
      if (opener) {
        if (open(opener.getAttribute('data-od-policy-open'))) e.preventDefault();
        return;
      }
      if (e.target.closest && e.target.closest('[data-od-policy-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- pre-order notification signup ----------
     One click reveals the field and puts the cursor in it. The form beneath is
     a plain Shopify customer form that posts normally, so the signup does not
     depend on this script to work. */

  function initNotify() {
    document.querySelectorAll('[data-od-notify]').forEach(function (box) {
      if (!once(box)) return;
      var open = box.querySelector('[data-od-notify-open]');
      var panel = box.querySelector('[data-od-notify-panel]');
      if (!open || !panel) return;
      open.addEventListener('click', function () {
        panel.hidden = false;
        open.hidden = true;
        var input = panel.querySelector('input[type="email"]');
        if (input) input.focus();
      });
    });
  }

  /* ---------- cart ----------
     Everything the bag does is sent with fetch so the page never reloads and
     the song is never cut off. Every path falls back to the plain Shopify form
     if anything goes wrong, so the bag still works with JavaScript disabled. */

  function cartAjaxOn() {
    return document.body.hasAttribute('data-od-ajax-cart') && !!window.fetch && !!window.FormData;
  }

  function refreshCartPage() {
    // only the bag page itself needs re-rendering; elsewhere the badge is enough
    if (!document.querySelector('[data-od-cart-form]') && !document.querySelector('.od-cart')) {
      return Promise.resolve();
    }
    var url = window.location.pathname + window.location.search;
    if (window.__odRefresh) return window.__odRefresh(url);

    var main = document.querySelector('#MainContent') || document.querySelector('main');
    if (!main || !window.DOMParser) { window.location.reload(); return Promise.resolve(); }
    var y = window.pageYOffset;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('bad status'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('#MainContent') || doc.querySelector('main');
        if (!incoming) throw new Error('no main');
        main.innerHTML = incoming.innerHTML;
        purgeStrayAudio(main);
        window.scrollTo(0, y);
        boot();
      })
      .catch(function () { window.location.reload(); });
  }

  function readCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); return c; });
  }

  function flashButton(button, text) {
    if (!button) return;
    if (button.hasAttribute('data-od-flashing')) return;
    button.setAttribute('data-od-flashing', '');
    var original = button.innerHTML;
    button.innerHTML = text;
    window.setTimeout(function () {
      button.innerHTML = original;
      button.removeAttribute('data-od-flashing');
    }, 1800);
  }

  var cartReady = false;
  function initCart() {
    var wrap = document.querySelector('[data-od-cart-form]');
    var form = wrap ? wrap.querySelector('form') : null;

    // no JavaScript cart: keep the original submit-on-change behaviour
    if (!cartAjaxOn()) {
      if (!form) return;
      form.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
        if (!once(input)) return;
        input.addEventListener('change', function () {
          form.requestSubmit ? form.requestSubmit(form.querySelector('[name="update"]')) : form.submit();
        });
      });
      return;
    }

    if (cartReady) return;   // delegated listeners survive every page swap
    cartReady = true;

    function changeLine(line, quantity) {
      document.body.setAttribute('data-od-cart-busy', '');
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart change failed'); return r.json(); })
        .then(function (c) {
          setCartCount(c.item_count);
          return refreshCartPage();
        })
        .then(function () { document.body.removeAttribute('data-od-cart-busy'); })
        .catch(function () {
          document.body.removeAttribute('data-od-cart-busy');
          window.location.href = '/cart';
        });
    }

    /* add to cart, from any product form */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.tagName !== 'FORM') return;
      var action = f.getAttribute('action') || '';
      var submitter = e.submitter || f.querySelector('[data-od-submit]');

      if (action.indexOf('/cart/add') !== -1) {
        // the dynamic checkout button posts on its own and must be left alone
        if (submitter && submitter.closest && submitter.closest('.shopify-payment-button')) return;
        e.preventDefault();
        var button = f.querySelector('[data-od-submit]') || submitter;
        if (button) button.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: new FormData(f)
        })
          .then(function (r) {
            return r.json().then(function (body) {
              if (!r.ok) throw new Error(body && body.description ? body.description : 'add failed');
              return body;
            });
          })
          .then(function () { return readCartCount(); })
          .then(function () {
            if (button) button.disabled = false;
            flashButton(button, 'Added to bag');
            return refreshCartPage();
          })
          .catch(function (err) {
            if (button) button.disabled = false;
            if (err && err.message && err.message !== 'add failed') {
              flashButton(button, err.message);
            } else if (f.submit) {
              f.submit();   // fall back to the real Shopify POST
            }
          });
        return;
      }

      /* the bag page: Update cart, and the note */
      if (f.closest && f.closest('[data-od-cart-form]')) {
        if (submitter && submitter.name === 'checkout') return;   // straight to checkout
        e.preventDefault();
        var updates = [];
        f.querySelectorAll('input[name="updates[]"]').forEach(function (input) {
          updates.push(parseInt(input.value, 10) || 0);
        });
        var note = f.querySelector('[name="note"]');
        document.body.setAttribute('data-od-cart-busy', '');
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates, note: note ? note.value : undefined })
        })
          .then(function (r) { if (!r.ok) throw new Error('update failed'); return r.json(); })
          .then(function (c) { setCartCount(c.item_count); return refreshCartPage(); })
          .then(function () { document.body.removeAttribute('data-od-cart-busy'); })
          .catch(function () {
            document.body.removeAttribute('data-od-cart-busy');
            window.location.href = '/cart';
          });
      }
    });

    /* quantity steppers and typed quantities on the bag page */
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.name !== 'updates[]') return;
      var cartForm = input.closest ? input.closest('[data-od-cart-form]') : null;
      if (!cartForm) return;
      var inputs = cartForm.querySelectorAll('input[name="updates[]"]');
      var line = Array.prototype.indexOf.call(inputs, input) + 1;
      if (line < 1) return;
      changeLine(line, parseInt(input.value, 10) || 0);
    });

    /* Remove links, which are ordinary /cart/change URLs */
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[href*="/cart/change"]') : null;
      if (!link || e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var u;
      try { u = new URL(link.href, location.href); } catch (err) { return; }
      var line = u.searchParams.get('line');
      var qty = u.searchParams.get('quantity');
      if (line === null || qty === null) return;
      e.preventDefault();
      changeLine(parseInt(line, 10), parseInt(qty, 10));
    });
  }

  /* ---------- collection sort ---------- */

  function initSort() {
    var select = document.querySelector('[data-od-sort]');
    if (!select || !once(select)) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- customer address forms ---------- */

  function initAddresses() {
    document.querySelectorAll('[data-od-address-toggle]').forEach(function (button) {
      if (!once(button)) return;
      button.addEventListener('click', function () {
        var target = document.getElementById(button.getAttribute('aria-controls'));
        if (!target) return;
        var open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        target.hidden = !open;
      });
    });

    document.querySelectorAll('[data-od-address-delete]').forEach(function (wrap) {
      if (!once(wrap)) return;
      var form = wrap.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', function (event) {
        if (!window.confirm(wrap.getAttribute('data-confirm') || 'Delete this address?')) {
          event.preventDefault();
        }
      });
    });

    if (window.Shopify && window.Shopify.CountryProvinceSelector) {
      document.querySelectorAll('[data-od-country-select]').forEach(function (select) {
        var provinceId = select.getAttribute('data-province-id');
        var wrapperId = select.getAttribute('data-province-wrapper-id');
        if (!provinceId || !wrapperId) return;
        new window.Shopify.CountryProvinceSelector(select.id, provinceId, { hideElement: wrapperId });
      });
    }
  }


  /* ---------- accordions ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-od-accordion] .od-acc__item').forEach(function (item) {
      if (!once(item)) return;
      var btn = item.querySelector('.od-acc__btn');
      var sign = item.querySelector('.od-acc__sign');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') !== 'true';
        item.setAttribute('data-open', String(open));
        btn.setAttribute('aria-expanded', String(open));
        if (sign) sign.innerHTML = open ? '&minus;' : '+';
      });
    });
  }

  /* ---------- selected option label on the product page ---------- */
  function initOptionLabels(root) {
    root.querySelectorAll('[data-od-option-group]').forEach(function (group) {
      if (!once(group)) return;
      var out = group.querySelector('[data-od-option-selected]');
      if (!out) return;
      group.addEventListener('change', function () {
        var c = group.querySelector('[data-od-option-input]:checked');
        if (c) out.textContent = c.value;
      });
    });

    // Fit/Size rendered by the theme when the product has no variants yet.
    // These are line-item properties, so they must stay out of variant matching.
    root.querySelectorAll('[data-od-prop-group]').forEach(function (group) {
      if (!once(group)) return;
      var out = group.querySelector('[data-od-prop-selected]');
      if (!out) return;
      group.addEventListener('change', function () {
        var c = group.querySelector('[data-od-prop-input]:checked');
        if (c) out.textContent = c.value;
      });
    });
  }

  /* ---------- song player ---------- */
  function fmt(t) {
    if (!isFinite(t)) return '0:00';
    var m = Math.floor(t / 60), s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }
  function initAudio() {
    document.querySelectorAll('[data-od-audio]').forEach(function (w) {
      if (!once(w)) return;
      var a = w.querySelector('[data-od-audio-el]');
      var btn = w.querySelector('[data-od-audio-toggle]');
      var play = w.querySelector('[data-od-icon-play]');
      var pause = w.querySelector('[data-od-icon-pause]');
      var seek = w.querySelector('[data-od-audio-seek]');
      var cur = w.querySelector('[data-od-audio-cur]');
      var dur = w.querySelector('[data-od-audio-dur]');
      if (!a || !btn) return;

      btn.addEventListener('click', function () {
        if (a.paused) { pauseOthers(a); a.play(); } else { a.pause(); }
      });
      a.addEventListener('play', function () { pauseOthers(a); });
      a.addEventListener('play', function () {
        if (play) play.hidden = true;
        if (pause) pause.hidden = false;
        btn.setAttribute('aria-label', 'Pause');
      });
      a.addEventListener('pause', function () {
        if (play) play.hidden = false;
        if (pause) pause.hidden = true;
        btn.setAttribute('aria-label', 'Play');
      });
      a.addEventListener('loadedmetadata', function () { if (dur) dur.textContent = fmt(a.duration); });
      a.addEventListener('timeupdate', function () {
        if (cur) cur.textContent = fmt(a.currentTime);
        if (seek && a.duration) seek.value = (a.currentTime / a.duration) * 100;
      });
      if (seek) seek.addEventListener('input', function () {
        if (a.duration) a.currentTime = (seek.value / 100) * a.duration;
      });
    });
  }


  /* ---------- cart badge in the header ---------- */

  function setCartCount(count) {
    var badge = document.querySelector('.od-cart-count');
    var link = document.querySelector('.od-header__actions a[href*="cart"]');
    if (link) link.setAttribute('aria-label', 'Cart, ' + count + ' items');
    if (count > 0) {
      if (!badge) {
        if (!link) return;
        badge = document.createElement('span');
        badge.className = 'od-cart-count';
        link.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function syncCartCount(incomingBadge) {
    setCartCount(incomingBadge ? parseInt(incomingBadge.textContent, 10) || 0 : 0);
  }

  /* Only one thing may ever sound at once, whichever player owns it. */
  function pauseOthers(keep) {
    document.querySelectorAll('[data-od-song-el], [data-od-audio-el], [data-od-vsound], [data-od-avideo]')
      .forEach(function (o) {
        if (o !== keep && !o.paused) o.pause();
      });
  }

  /* Remove any audio that arrives inside the swapped page body. The only
     player allowed to exist is the one rendered by layout/theme.liquid, which
     lives outside #MainContent and is therefore never replaced. */
  function purgeStrayAudio(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-od-songbar]').forEach(function (dupe) {
      if (dupe === window.__odSongBar) return;
      var el = dupe.querySelector('[data-od-song-el]');
      if (el) { try { el.pause(); } catch (e) {} el.removeAttribute('src'); try { el.load(); } catch (e) {} }
      dupe.remove();
    });
    scope.querySelectorAll('[data-od-vsound], [data-od-avideo]').forEach(function (el) {
      if (window.__odFilm && window.__odFilm.el && window.__odFilm.el.contains(el)) return;
      try { el.pause(); } catch (e) {}
    });
    scope.querySelectorAll('[data-od-audio-el]').forEach(function (el) {
      if (!window.__odSongBar) return;   // no global player: in-page one may stay
      try { el.pause(); } catch (e) {}
      el.removeAttribute('src');
      var host = el.closest ? el.closest('[data-od-audio]') : null;
      if (host) host.remove(); else el.remove();
    });
  }

  /* ---------- global song bar: continues across page navigation ---------- */
  var songBarReady = false;
  function initSongBar() {
    var bars = document.querySelectorAll('[data-od-songbar]');
    if (!bars.length) return;

    // The real player is the one outside the main content region, because that
    // is the node soft navigation never touches. Anything else is a duplicate.
    var main = document.querySelector('#MainContent') || document.querySelector('main');
    var bar = null;
    for (var b = 0; b < bars.length; b++) {
      if (!main || !main.contains(bars[b])) { bar = bars[b]; break; }
    }
    if (!bar) bar = bars[0];
    if (window.__odSongBar && document.contains(window.__odSongBar)) bar = window.__odSongBar;

    // drop every rogue copy before it can sound
    for (var i = 0; i < bars.length; i++) {
      if (bars[i] === bar) continue;
      var extra = bars[i].querySelector('[data-od-song-el]');
      if (extra) { try { extra.pause(); } catch (e) {} extra.removeAttribute('src'); try { extra.load(); } catch (e) {} }
      bars[i].remove();
    }

    if (songBarReady || !once(bar)) return;
    songBarReady = true;
    window.__odSongBar = bar;
    var a = bar.querySelector('[data-od-song-el]');
    if (!a) return;

    var KEY = 'od-song:' + (bar.getAttribute('data-od-song-key') || 'default');

    /* How long a saved "playing" state stays valid. Long enough to cover a page
       load, short enough that a tab returned to later starts silent. */
    var RESUME_WINDOW = 60000;
    var ARM_WINDOW = 8000;
    var toggle = bar.querySelector('[data-od-song-toggle]');
    var iPlay = bar.querySelector('[data-od-song-play]');
    var iPause = bar.querySelector('[data-od-song-pause]');
    var seek = bar.querySelector('[data-od-song-seek]');
    var cur = bar.querySelector('[data-od-song-cur]');
    var dur = bar.querySelector('[data-od-song-dur]');
    var muteBtn = bar.querySelector('[data-od-song-mute]');
    var iVol = bar.querySelector('[data-od-song-vol]');
    var iMuted = bar.querySelector('[data-od-song-muted]');
    var restart = bar.querySelector('[data-od-song-restart]');
    var collapse = bar.querySelector('[data-od-song-collapse]');
    var expand = bar.querySelector('[data-od-song-expand]');
    var scrubbing = false;

    function store(patch) {
      var s = read();
      for (var k in patch) s[k] = patch[k];
      s.at = Date.now();
      try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    }
    function read() {
      try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
    }

    var unloading = false;
    var suspended = false;   // paused only because the About film is playing
    var saved = read();
    if (saved.collapsed) bar.setAttribute('data-collapsed', 'true');
    if (saved.muted) { a.muted = true; if (iVol) iVol.hidden = true; if (iMuted) iMuted.hidden = false; }
    if (typeof saved.vol === 'number' && saved.vol >= 0 && saved.vol <= 1) a.volume = saved.vol;

    var target = saved.t || 0;
    var seekDone = target < 0.5;   // nothing to restore
    var restored = false;

    // First visit: only metadata is fetched, so a visitor who never presses
    // Play never downloads the track. Once they have started it, buffer the
    // whole file so every later page can resume almost instantly.
    if (saved.started || saved.playing || target > 0.5) a.preload = 'auto';

    function applySeek() {
      if (seekDone) return;
      if (!a.duration || target >= a.duration - 0.5) { seekDone = true; return; }
      try { a.currentTime = target; } catch (e) { return; }
      if (Math.abs(a.currentTime - target) < 1.5) seekDone = true;
    }

    function restore() {
      if (restored) return;
      restored = true;
      if (dur) dur.textContent = fmt(a.duration);
      applySeek();

      /* Resume only when this is a real continuation: the track was playing
         when the last page was left, and that was moments ago. A tab left open
         over lunch starts silent and waits to be asked, which is the difference
         between carrying playback across a click and autoplaying at someone. */
      if (saved.playing && Date.now() - (saved.at || 0) < RESUME_WINDOW) tryPlay();
      else if (saved.playing) store({ playing: false });
    }

    // Resume, and if the browser blocks it because this page load has had no
    // interaction yet, latch on to the next gesture — but only for a few
    // seconds. Left unbounded, a tap on a product three minutes later would
    // start the music, which is indistinguishable from autoplay to the person
    // it happens to.
    var armed = false;
    var armTimer = null;
    function tryPlay() {
      var p;
      try { p = a.play(); } catch (e) { arm(); return; }
      if (p && p.catch) p.catch(arm);
    }
    function arm() {
      if (armed) return;
      armed = true;
      var events = ['pointerdown', 'touchstart', 'keydown', 'click'];
      var disarm = function () {
        armed = false;
        if (armTimer) { clearTimeout(armTimer); armTimer = null; }
        events.forEach(function (t) { document.removeEventListener(t, resume, true); });
      };
      var resume = function () {
        disarm();
        var st = read();
        if (st.playing && Date.now() - (st.at || 0) < RESUME_WINDOW) tryPlay();
      };
      events.forEach(function (t) { document.addEventListener(t, resume, true); });
      armTimer = window.setTimeout(function () {
        disarm();
        // the resume never landed, so stop claiming it is still playing
        if (a.paused) store({ playing: false });
      }, ARM_WINDOW);
    }

    a.addEventListener('loadedmetadata', function () { report('loaded OK — ' + Math.round(a.duration) + 's'); });
    a.addEventListener('loadedmetadata', restore);
    a.addEventListener('canplay', applySeek);
    a.addEventListener('loadeddata', applySeek);
    // metadata can already be loaded before this script runs (cached audio),
    // in which case the event above never fires - so check directly too
    if (a.readyState >= 1) restore();

    if (toggle) toggle.addEventListener('click', function () {
      if (a.paused) {
        pauseOthers(a);
        var pr = a.play();
        if (pr && pr.catch) {
          pr.catch(function (err) {
            report('play() rejected - ' + (err && err.name ? err.name : 'unknown'));
            if (iPlay) iPlay.hidden = false;
            if (iPause) iPause.hidden = true;
          });
        }
      } else {
        a.pause();
      }
    });

    a.addEventListener('play', function () {
      pauseOthers(a);
      if (a.preload !== 'auto') a.preload = 'auto';
      if (iPlay) iPlay.hidden = true;
      if (iPause) iPause.hidden = false;
      if (toggle) toggle.setAttribute('aria-label', 'Pause');
      store({ playing: true, started: true });
    });
    a.addEventListener('pause', function () {
      if (iPlay) iPlay.hidden = false;
      if (iPause) iPause.hidden = true;
      if (toggle) toggle.setAttribute('aria-label', 'Play');
      if (unloading || suspended) return;   // leaving, or the film has the stage
      store({ playing: false, t: a.currentTime });
    });
    a.addEventListener('ended', function () { store({ playing: false, t: 0 }); });

    // If the file cannot be loaded (wrong name, not uploaded), take the bar
    // away instead of leaving a play button that does nothing.
    var stat = document.querySelector('[data-od-songstat-txt]');
    function report(msg) {
      if (window.console && console.warn) console.warn('[Oddsmakers audio] ' + msg);
      if (stat) stat.textContent = msg;   // theme editor only
    }
    report('source: ' + (a.getAttribute('src') || 'none'));

    a.addEventListener('error', function () {
      var code = a.error ? a.error.code : 0;
      var why = {1:'aborted', 2:'network error', 3:'cannot decode', 4:'file not found or unsupported'}[code] || 'unknown';
      report('FAILED (' + why + ') — ' + (a.currentSrc || 'no src'));
      if (!stat) {            // live store only: hide rather than show a dead control
        bar.setAttribute('hidden', '');
        bar.style.display = 'none';
      }
    });
    // persist volume and mute however they change, not only via the button
    a.addEventListener('volumechange', function () {
      if (iVol) iVol.hidden = a.muted;
      if (iMuted) iMuted.hidden = !a.muted;
      store({ muted: a.muted, vol: a.volume });
    });

    var last = 0;
    a.addEventListener('timeupdate', function () {
      // don't overwrite the saved position until the restore seek has landed
      if (!seekDone) { applySeek(); return; }
      if (cur) cur.textContent = fmt(a.currentTime);
      if (seek && a.duration && !scrubbing) seek.value = (a.currentTime / a.duration) * 100;
      var now = Date.now();
      if (now - last > 900) { last = now; store({ t: a.currentTime }); }
    });
    // Stop this page's audio as it goes away. Without this the outgoing page
    // can keep sounding while the next page starts its own copy, which is what
    // produced overlapping tracks on fast navigation.
    function teardown() {
      if (unloading) return;
      unloading = true;
      store({ t: a.currentTime, playing: !a.paused });
      a.pause();
    }
    window.addEventListener('pagehide', teardown);
    window.addEventListener('beforeunload', teardown);

    // iOS can discard a backgrounded tab without firing pagehide
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' && !unloading) {
        store({ t: a.currentTime, playing: !a.paused });
      }
    });

    // let soft navigation flush the exact position the instant a link is used,
    // and let the About film borrow the stage and hand it straight back
    window.__odSong = {
      el: a,
      save: function () { if (!unloading) store({ t: a.currentTime, playing: !a.paused }); },
      // the film is taking over: remember that the song was running, and stop it
      // without recording a pause the visitor never asked for
      suspend: function () {
        if (a.paused) { suspended = false; return; }
        store({ t: a.currentTime, playing: true });
        suspended = true;
        a.pause();
      },
      // the film has finished with it: carry on from exactly where we stopped
      release: function () {
        if (!suspended) return;
        suspended = false;
        tryPlay();
      },
      suspended: function () { return suspended; }
    };

    // returning via the back/forward cache: the element is still alive
    window.addEventListener('pageshow', function (e) {
      unloading = false;
      if (!e.persisted) return;
      var st = read();
      if (st.playing && a.paused && Date.now() - (st.at || 0) < RESUME_WINDOW) a.play().catch(function () {});
    });

    if (seek) {
      seek.addEventListener('pointerdown', function () { scrubbing = true; });
      seek.addEventListener('change', function () { scrubbing = false; });
      seek.addEventListener('input', function () {
        if (a.duration) { a.currentTime = (seek.value / 100) * a.duration; store({ t: a.currentTime }); }
      });
    }
    if (muteBtn) muteBtn.addEventListener('click', function () {
      a.muted = !a.muted;
      muteBtn.setAttribute('aria-label', a.muted ? 'Unmute' : 'Mute');
    });

    /* Volume slider. Moving it off zero also unmutes, because a visitor who
       drags the volume up plainly wants to hear something. */
    var volSlider = bar.querySelector('[data-od-song-volume]');
    if (volSlider) {
      volSlider.value = Math.round((typeof saved.vol === 'number' ? saved.vol : a.volume) * 100);
      volSlider.addEventListener('input', function () {
        var next = parseInt(volSlider.value, 10) / 100;
        if (isNaN(next)) return;
        a.volume = Math.min(1, Math.max(0, next));
        if (a.volume > 0 && a.muted) a.muted = false;
      });
      a.addEventListener('volumechange', function () {
        if (document.activeElement === volSlider) return;   // don't fight the drag
        volSlider.value = Math.round((a.muted ? 0 : a.volume) * 100);
      });
    }
    if (restart) restart.addEventListener('click', function () {
      a.currentTime = 0; store({ t: 0 }); if (a.paused) a.play();
    });
    if (collapse) collapse.addEventListener('click', function () {
      bar.setAttribute('data-collapsed', 'true'); store({ collapsed: true });
    });
    if (expand) expand.addEventListener('click', function () {
      bar.setAttribute('data-collapsed', 'false'); store({ collapsed: false });
    });
  }


  /* ---------- the About film, and its soundtrack segment ----------
     One video, one soundtrack instance, and a clean handover with the sitewide
     music: the song steps aside while the film runs and resumes from exactly
     where it stopped the moment the film pauses, ends or leaves the page. */

  function initFilm() {
    var film = document.querySelector('[data-od-film]');
    if (!film) return;
    if (!once(film)) return;

    var video = film.querySelector('[data-od-avideo]');
    var sound = film.querySelector('[data-od-vsound]');
    if (!video) return;

    // Belt and braces: if a swap ever left a second soundtrack behind, keep the
    // first and destroy the rest before either can make a noise.
    var extras = film.querySelectorAll('[data-od-vsound]');
    for (var i = 1; i < extras.length; i++) {
      try { extras[i].pause(); } catch (e) {}
      extras[i].remove();
    }

    var num = function (v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; };
    var trackSrc = film.getAttribute('data-track-src') || '';
    var start = Math.max(0, num(film.getAttribute('data-track-start'), 0));
    var end = num(film.getAttribute('data-track-end'), 0);          // 0 = to the end
    var trackVol = num(film.getAttribute('data-track-volume'), 100) / 100;
    var loopSeg = film.getAttribute('data-track-loop') === 'true';
    var nativeOn = film.getAttribute('data-native-audio') === 'true';
    var nativeVol = num(film.getAttribute('data-native-volume'), 60) / 100;

    /* A film exported with the music already mixed in needs no second source:
       it simply plays its own audio. The sitewide song still steps aside, so
       the two can never overlap. */
    var useSegment = film.getAttribute('data-audio-mode') !== 'native';
    if (!useSegment) { nativeOn = true; nativeVol = 1; }

    var big = film.querySelector('[data-od-film-big]');
    var toggle = film.querySelector('[data-od-film-toggle]');
    var iPlay = film.querySelector('[data-od-film-play]');
    var iPause = film.querySelector('[data-od-film-pause]');
    var seek = film.querySelector('[data-od-film-seek]');
    var cur = film.querySelector('[data-od-film-cur]');
    var dur = film.querySelector('[data-od-film-dur]');
    var muteBtn = film.querySelector('[data-od-film-mute]');
    var iVolOn = film.querySelector('[data-od-film-vol-on]');
    var iVolOff = film.querySelector('[data-od-film-vol-off]');
    var volSlider = film.querySelector('[data-od-film-volume]');
    var fullBtn = film.querySelector('[data-od-film-full]');

    var master = 1;        // the volume slider, applied to whatever is audible
    var muted = false;
    var scrubbing = false;
    var soundReady = false;

    /* The film's own audio is off unless the merchant turns it on, so the
       Oddsmakers segment is never fighting the original track. */
    video.muted = !nativeOn;
    video.playsInline = true;

    function applyVolume() {
      video.muted = muted || !nativeOn;
      video.volume = Math.min(1, Math.max(0, nativeVol * master));
      if (sound) {
        sound.muted = muted;
        sound.volume = Math.min(1, Math.max(0, trackVol * master));
      }
      if (iVolOn) iVolOn.hidden = muted;
      if (iVolOff) iVolOff.hidden = !muted;
      if (muteBtn) muteBtn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
    }

    /* Where the soundtrack should be for a given point in the film. */
    function trackPos() {
      var stop = end > start ? end : Infinity;
      var span = stop - start;
      var offset = video.currentTime;
      if (loopSeg && span !== Infinity && span > 0.2) offset = offset % span;
      var target = start + offset;
      if (target >= stop) return null;    // the segment has run out
      return target;
    }

    /* The soundtrack file is only fetched once the visitor starts the film, so
       a seek may be asked for before its metadata has arrived. Hold the request
       and apply it the moment the element can accept it. */
    var pendingSeek = null;

    function applyPending() {
      if (pendingSeek === null || !sound) return;
      if (!sound.duration) return;
      try { sound.currentTime = Math.min(pendingSeek, sound.duration - 0.05); } catch (e) { return; }
      pendingSeek = null;
    }

    function syncSound(force) {
      if (!useSegment || !sound || !soundReady) return;
      var target = trackPos();
      if (target === null) { if (!sound.paused) sound.pause(); return; }
      if (!sound.duration) { pendingSeek = target; return; }
      if (force || Math.abs(sound.currentTime - target) > 0.25) {
        try { sound.currentTime = target; } catch (e) {}
      }
    }

    function startSound() {
      if (!useSegment || !sound || !trackSrc) return;
      if (!soundReady) {
        sound.preload = 'auto';
        sound.src = trackSrc;
        soundReady = true;
        try { sound.load(); } catch (e) {}
      }
      applyVolume();
      var target = trackPos();
      if (target === null) return;
      pendingSeek = target;
      applyPending();
      var p = sound.play();
      if (p && p.catch) p.catch(function () {});
    }

    function stopSound() {
      if (!sound) return;
      try { sound.pause(); } catch (e) {}
    }

    if (sound && useSegment) {
      sound.addEventListener('loadedmetadata', applyPending);
      sound.addEventListener('canplay', applyPending);
      sound.addEventListener('playing', applyPending);
      // hold the segment inside its configured window
      sound.addEventListener('timeupdate', function () {
        if (end > start && sound.currentTime >= end - 0.05) {
          if (loopSeg && !video.paused) {
            try { sound.currentTime = start; } catch (e) {}
          } else {
            sound.pause();
          }
        }
      });
    }

    /* handing the stage back and forth with the sitewide player */
    function takeStage() {
      if (window.__odSong && window.__odSong.suspend) window.__odSong.suspend();
      pauseOthers(video);
    }
    function giveStageBack() {
      stopSound();
      if (window.__odSong && window.__odSong.release) window.__odSong.release();
    }

    function fmtTime(v) { return fmt(v); }

    /* ---- video events drive everything else ---- */
    video.addEventListener('play', function () {
      film.setAttribute('data-playing', 'true');
      // shrink the sitewide player to its badge so it cannot sit over the film
      // controls. Nothing is written to storage, so the visitor's own collapsed
      // or expanded choice comes straight back afterwards.
      document.body.setAttribute('data-od-film-playing', '');
      if (iPlay) iPlay.hidden = true;
      if (iPause) iPause.hidden = false;
      if (toggle) toggle.setAttribute('aria-label', 'Pause');
      takeStage();
      startSound();
    });

    video.addEventListener('pause', function () {
      film.setAttribute('data-playing', 'false');
      document.body.removeAttribute('data-od-film-playing');
      if (iPlay) iPlay.hidden = false;
      if (iPause) iPause.hidden = true;
      if (toggle) toggle.setAttribute('aria-label', 'Play');
      giveStageBack();
    });

    video.addEventListener('ended', function () {
      film.setAttribute('data-playing', 'false');
      document.body.removeAttribute('data-od-film-playing');
      film.removeAttribute('data-started');
      if (iPlay) iPlay.hidden = false;
      if (iPause) iPause.hidden = true;
      video.currentTime = 0;
      if (seek) seek.value = 0;
      if (cur) cur.textContent = '0:00';
      giveStageBack();
    });

    /* A film that cannot load must not silently swallow the site music. */
    var errBox = film.querySelector('[data-od-film-error]');
    video.addEventListener('error', function () {
      if (errBox) errBox.hidden = false;
      film.removeAttribute('data-started');
      stopSound();
      if (window.__odSong && window.__odSong.release) window.__odSong.release();
    });

    video.addEventListener('seeking', function () { syncSound(true); });
    video.addEventListener('seeked', function () { syncSound(true); });

    video.addEventListener('loadedmetadata', function () {
      if (dur) dur.textContent = fmtTime(video.duration);
    });
    if (video.readyState >= 1 && dur) dur.textContent = fmtTime(video.duration);

    video.addEventListener('timeupdate', function () {
      if (cur) cur.textContent = fmtTime(video.currentTime);
      if (seek && video.duration && !scrubbing) {
        seek.value = (video.currentTime / video.duration) * 100;
      }
      if (!video.paused) syncSound(false);
    });

    /* ---- controls ---- */
    function playPause() {
      if (video.paused) {
        film.setAttribute('data-started', 'true');
        var p = video.play();
        if (p && p.catch) p.catch(function () { film.removeAttribute('data-started'); });
      } else {
        video.pause();
      }
    }
    if (big) big.addEventListener('click', playPause);
    if (toggle) toggle.addEventListener('click', playPause);
    video.addEventListener('click', function () { if (film.hasAttribute('data-started')) playPause(); });

    if (seek) {
      seek.addEventListener('pointerdown', function () { scrubbing = true; });
      seek.addEventListener('change', function () { scrubbing = false; syncSound(true); });
      seek.addEventListener('input', function () {
        if (!video.duration) return;
        video.currentTime = (seek.value / 100) * video.duration;
        if (cur) cur.textContent = fmtTime(video.currentTime);
      });
    }

    if (muteBtn) muteBtn.addEventListener('click', function () {
      muted = !muted;
      applyVolume();
    });

    if (volSlider) volSlider.addEventListener('input', function () {
      master = (parseFloat(volSlider.value) || 0) / 100;
      if (master > 0 && muted) muted = false;
      applyVolume();
    });

    if (fullBtn) fullBtn.addEventListener('click', function () {
      // full-screen the whole player so the custom controls come along
      var doc = document;
      if (doc.fullscreenElement || doc.webkitFullscreenElement) {
        (doc.exitFullscreen || doc.webkitExitFullscreen || function () {}).call(doc);
        return;
      }
      var req = film.requestFullscreen || film.webkitRequestFullscreen;
      if (req) req.call(film);
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();  // iPhone
    });

    /* If the sitewide player is started by hand while the film is running, the
       film stops rather than talking over it. */
    if (window.__odSong && window.__odSong.el) {
      window.__odSong.el.addEventListener('play', function () {
        if (!video.paused) video.pause();
      });
    }

    /* Leaving the page mid-film: stop the soundtrack and give the song back. */
    function teardown() {
      document.body.removeAttribute('data-od-film-playing');
      if (!video.paused) { try { video.pause(); } catch (e) {} }
      stopSound();
      if (window.__odSong && window.__odSong.release) window.__odSong.release();
    }
    window.__odFilm = { teardown: teardown, el: film };
    window.addEventListener('pagehide', teardown);

    applyVolume();
  }

  /* ---------- soft navigation: keeps the song alive between pages ----------
     Only ordinary same-origin content links are intercepted. Cart, checkout,
     account, apps, files and every form submission navigate normally, and any
     failure falls straight back to a real page load. ---------------------- */
  var softNavReady = false;
  /* ---------- app compatibility across soft navigation ----------

     Swapping #MainContent keeps the song playing, but it also means Shopify
     app blocks are torn down and rebuilt without the app ever being told. Two
     things bridge that gap:

       runScripts   re-executes <script> tags in swapped-in markup, because
                    innerHTML parses them but never runs them
       announcePage fires the same events Shopify's own theme editor fires when
                    a section is re-rendered, which is what app extensions
                    listen for to re-initialise

     Without these, an app that works on a hard page load appears broken the
     moment a visitor arrives at the page by clicking a link. */

  function runScripts(root) {
    if (!root) return;
    var scripts = root.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var old = scripts[i];
      var copy = document.createElement('script');
      for (var a = 0; a < old.attributes.length; a++) {
        copy.setAttribute(old.attributes[a].name, old.attributes[a].value);
      }
      if (!old.src) copy.textContent = old.textContent;
      old.parentNode.replaceChild(copy, old);
    }
  }

  function announcePage(root) {
    if (!root || typeof CustomEvent !== 'function') return;
    // one event per section, matching what the theme editor emits
    var sections = root.querySelectorAll('[id^="shopify-section-"]');
    for (var i = 0; i < sections.length; i++) {
      sections[i].dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: sections[i].id.replace('shopify-section-', '') }
      }));
    }
    // and one page-level event for anything listening more broadly
    document.dispatchEvent(new CustomEvent('oddsmakers:page:load', {
      bubbles: true,
      detail: { url: location.href }
    }));
  }

  function initSoftNav() {
    if (softNavReady) return;        // boot() re-runs after every soft nav
    var bar = document.querySelector('[data-od-songbar]');
    if (!bar || bar.getAttribute('data-od-softnav') !== 'true') return;
    if (!window.fetch || !window.history || !window.DOMParser) return;
    var MAIN = '#MainContent';
    var main = document.querySelector(MAIN);
    if (!main) { main = document.querySelector('main'); MAIN = 'main'; }
    if (!main) return;

    /* Everything here is either a Shopify-owned flow or something that must
       hit the server for real. The shopping bag is deliberately NOT on the
       list: viewing it is an ordinary page and the music should carry through
       it. Cart mutations (/cart/add, /cart/change, /cart/update) are handled
       by the AJAX layer below and never navigate at all. */
    var SKIP = ['/checkout', '/account', '/challenge', '/apps', '/a/',
                '/services', '/tools', '/admin', '/password'];

    /* Safety valve. Product pages carry the most app surface of any page on the
       store — bundles, upsells, reviews, subscriptions. If an app cannot cope
       with being re-initialised after a swap, this makes product links do a
       normal page load instead, at the cost of a brief gap in the song. The
       resume window covers that gap, so playback picks itself back up.
       Theme settings -> Song -> "Full page loads on product pages". */
    if (bar.getAttribute('data-od-softnav-skip-products') === 'true') {
      SKIP.push('/products/');
    }

    function eligible(a) {
      if (!a || !a.getAttribute('href')) return false;
      if (a.target && a.target !== '_self') return false;
      if (a.hasAttribute('download') || a.hasAttribute('data-no-softnav')) return false;
      var u;
      try { u = new URL(a.href, location.href); } catch (e) { return false; }
      if (u.origin !== location.origin) return false;
      if (u.hash && u.pathname === location.pathname) return false;
      for (var i = 0; i < SKIP.length; i++) if (u.pathname.indexOf(SKIP[i]) === 0) return false;
      // /cart is fine, /cart/<anything> mutates the bag and must not be faked
      if (u.pathname.indexOf('/cart/') === 0) return false;
      if (/\.(pdf|zip|jpe?g|png|gif|webp|svg|ico|mp4|mov|mp3|wav|csv|xlsx?|docx?|txt|xml|json)$/i.test(u.pathname)) return false;
      return true;
    }

    softNavReady = true;
    var busy = false;
    function go(url, push, replaceWith) {
      if (busy) return;
      busy = true;
      // stop the About film before its markup is swapped away, so the soundtrack
      // cannot be orphaned and the sitewide song is handed straight back
      if (window.__odFilm) { window.__odFilm.teardown(); window.__odFilm = null; }
      if (window.__odSong) window.__odSong.save();
      document.body.setAttribute('data-od-navigating', '');
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('bad status');
          var ct = r.headers.get('content-type') || '';
          if (ct.indexOf('text/html') === -1) throw new Error('not html');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector(MAIN) || doc.querySelector('main');
          if (!incoming) throw new Error('no main');

          main.innerHTML = incoming.innerHTML;
          document.title = doc.title;

          /* innerHTML deliberately does not execute <script> tags, so any app
             markup that arrives with an inline initialiser dies silently on a
             soft navigation. Re-run them so Shopify app blocks behave the same
             way they would on a normal page load. */
          runScripts(main);

          // a swapped-in page must never bring a second player with it
          purgeStrayAudio(main);

          // the body carries the template name and the dark-page flag, both of
          // which the header and the About page style themselves from
          if (doc.body) {
            document.body.className = doc.body.className;
            var theme = doc.body.getAttribute('data-od-theme');
            if (theme) document.body.setAttribute('data-od-theme', theme);
            else document.body.removeAttribute('data-od-theme');
          }

          var canonical = document.querySelector('link[rel="canonical"]');
          var newCanonical = doc.querySelector('link[rel="canonical"]');
          if (canonical && newCanonical) canonical.setAttribute('href', newCanonical.getAttribute('href'));

          // refresh the cart badge and active nav without touching the player
          syncCartCount(doc.querySelector('.od-cart-count'));

          var oldNav = document.querySelectorAll('.od-nav__link');
          var newNav = doc.querySelectorAll('.od-nav__link');
          if (oldNav.length === newNav.length) {
            for (var i = 0; i < oldNav.length; i++) {
              if (newNav[i].hasAttribute('aria-current')) oldNav[i].setAttribute('aria-current', 'page');
              else oldNav[i].removeAttribute('aria-current');
            }
          }

          if (push) history.pushState({ od: 1 }, '', replaceWith || url);
          window.scrollTo(0, 0);
          boot();
          announcePage(main);
          busy = false;
          document.body.removeAttribute('data-od-navigating');
        })
        .catch(function () { window.location.href = url; });
    }

    // re-render the current page in place, keeping scroll and the player
    function refresh(url) {
      if (busy) return Promise.resolve();
      busy = true;
      var y = window.pageYOffset;
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('bad status'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector(MAIN) || doc.querySelector('main');
          if (!incoming) throw new Error('no main');
          main.innerHTML = incoming.innerHTML;
          runScripts(main);
          purgeStrayAudio(main);
          syncCartCount(doc.querySelector('.od-cart-count'));
          window.scrollTo(0, y);
          boot();
          announcePage(main);
          busy = false;
        })
        .catch(function () { busy = false; window.location.href = url; });
    }
    window.__odRefresh = refresh;

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!eligible(a)) return;
      e.preventDefault();
      go(a.href, true);
    });

    window.addEventListener('popstate', function () { go(location.href, false); });

    // GET forms (search) can be soft-navigated too
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.method && f.method.toLowerCase() !== 'get') return;
      var action = f.getAttribute('action') || location.pathname;
      var u;
      try { u = new URL(action, location.href); } catch (err) { return; }
      if (u.origin !== location.origin) return;
      for (var i = 0; i < SKIP.length; i++) if (u.pathname.indexOf(SKIP[i]) === 0) return;
      e.preventDefault();
      var qs = new URLSearchParams(new FormData(f)).toString();
      go(u.pathname + (qs ? '?' + qs : ''), true);
    });
  }

  /* ---------- announcement bar ----------
     Dismissal lasts for the session only. The key includes a hash of the
     message, so changing the announcement shows it again to everyone rather
     than staying hidden behind an old dismissal. */

  function initAnnounce() {
    document.querySelectorAll('[data-od-announce]').forEach(function (bar) {
      if (!once(bar)) return;
      var key = 'od-announce:' + (bar.getAttribute('data-od-announce-key') || 'default');
      var closer = bar.querySelector('[data-od-announce-close]');

      try {
        if (sessionStorage.getItem(key) === 'off') { bar.hidden = true; return; }
      } catch (e) {}

      if (!closer) return;
      closer.addEventListener('click', function () {
        bar.hidden = true;
        try { sessionStorage.setItem(key, 'off'); } catch (e) {}
      });
    });
  }

  /* ---------- anchor scrolling ----------
     Soft navigation would otherwise try to fetch "#make-your-own-odds" as a
     page. These links are marked data-no-softnav, and this handler does the
     scroll itself so focus lands on the target for keyboard and screen-reader
     users rather than staying behind on the button. */

  var anchorsReady = false;
  function initAnchors() {
    if (anchorsReady) return;
    anchorsReady = true;

    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[data-od-anchor]') : null;
      if (!link || e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var id = (link.getAttribute('href') || '').replace(/^.*#/, '');
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;   // let the browser try, rather than swallow the click

      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      try { target.focus({ preventScroll: true }); } catch (err) {}
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }

  /* ---------- build your rotation ----------
     Three real products, three real line items, one add. The bundle price comes
     from an automatic discount in Shopify Admin — nothing here invents a total,
     so if the discount is missing the customer is charged full price rather than
     shown a saving that never arrives. */

  function initBundle() {
    document.querySelectorAll('[data-od-bundle]').forEach(function (root) {
      if (!once(root)) return;

      var total = parseInt(root.getAttribute('data-slots'), 10) || 3;
      var property = root.getAttribute('data-property') || '';
      var addedText = root.getAttribute('data-added-text') || 'Added to bag';

      var slots = root.querySelectorAll('[data-od-bundle-slot]');
      var tiles = root.querySelectorAll('[data-od-bundle-pick]');
      var progress = root.querySelector('[data-od-bundle-progress]');
      var addBtn = root.querySelector('[data-od-bundle-add]');
      var errorEl = root.querySelector('[data-od-bundle-error]');
      var sizeStep = root.querySelector('[data-od-bundle-size-step]');
      var sizeFor = root.querySelector('[data-od-bundle-size-for]');
      var sizeVals = root.querySelector('[data-od-bundle-size-vals]');
      var sizeCancel = root.querySelector('[data-od-bundle-size-cancel]');

      var progressTemplate = progress ? progress.textContent : '';
      var chosen = [];          // { id, title, image, size, variantId, fit, productId }
      var pending = null;       // the tile waiting for a size

      function readTile(tile) {
        var node = tile.querySelector('[data-od-bundle-data]');
        if (!node) return { variants: [], sizes: [] };
        try { return JSON.parse(node.textContent); } catch (e) { return { variants: [], sizes: [] }; }
      }

      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      }

      function render() {
        slots.forEach(function (slot, i) {
          var pick = chosen[i];
          var media = slot.querySelector('[data-od-bundle-slot-media]');
          var name = slot.querySelector('[data-od-bundle-slot-name]');
          var size = slot.querySelector('[data-od-bundle-slot-size]');
          var clear = slot.querySelector('[data-od-bundle-clear]');

          if (pick) {
            slot.setAttribute('data-filled', 'true');
            if (name) name.textContent = pick.title;
            if (size) size.textContent = pick.fit ? pick.size + ' · ' + pick.fit : pick.size;
            if (clear) clear.hidden = false;
            if (media) {
              media.innerHTML = '';
              if (pick.image) {
                var img = document.createElement('img');
                img.src = pick.image;
                img.alt = '';
                media.appendChild(img);
              } else {
                media.innerHTML = '<span class="od-bundle__slot-num">' + (i + 1) + '</span>';
              }
            }
          } else {
            slot.setAttribute('data-filled', 'false');
            if (name) name.textContent = slot.getAttribute('data-empty-label') || name.getAttribute('data-empty') || name.textContent;
            if (size) size.textContent = '';
            if (clear) clear.hidden = true;
            if (media) media.innerHTML = '<span class="od-bundle__slot-num">' + (i + 1) + '</span>';
          }
        });

        if (progress && progressTemplate) {
          progress.textContent = progressTemplate
            .replace('[n]', chosen.length)
            .replace('[total]', total);
        }

        // a colourway already in the rotation is marked, but can be picked again
        tiles.forEach(function (tile) {
          var id = tile.getAttribute('data-id');
          var used = chosen.some(function (c) { return c.productId === id; });
          tile.setAttribute('data-picked', used ? 'true' : 'false');
        });

        if (addBtn) addBtn.disabled = chosen.length < total;
      }

      function openSizeStep(tile) {
        var data = readTile(tile);
        pending = tile;
        if (sizeFor) sizeFor.textContent = tile.getAttribute('data-title') || '';
        if (!sizeVals) return;

        sizeVals.innerHTML = '';
        var sizeIndex = parseInt(tile.getAttribute('data-size-index'), 10) || 0;

        (data.sizes || []).forEach(function (label) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'od-bundle__size-btn';
          btn.textContent = label;

          /* Match the variant carrying this size. With no size option on the
             product, the size travels as a line-item property on the default
             variant instead — the same fallback the product page uses. */
          var variant = null;
          if (sizeIndex > 0) {
            variant = (data.variants || []).filter(function (v) {
              return v.options && v.options[sizeIndex - 1] === label;
            })[0];
          } else {
            variant = (data.variants || []).filter(function (v) { return v.available; })[0] ||
                      (data.variants || [])[0];
          }

          if (!variant || (sizeIndex > 0 && !variant.available)) {
            btn.disabled = true;
            btn.title = 'Sold out';
          }

          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            chosen.push({
              productId: tile.getAttribute('data-id'),
              title: tile.getAttribute('data-title') || '',
              image: tile.getAttribute('data-image') || '',
              fit: tile.getAttribute('data-fit') || '',
              size: label,
              variantId: variant.id,
              useProperty: sizeIndex === 0
            });
            closeSizeStep();
            showError('');
            render();
          });

          sizeVals.appendChild(btn);
        });

        if (sizeStep) {
          sizeStep.hidden = false;
          sizeStep.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }

      function closeSizeStep() {
        pending = null;
        if (sizeStep) sizeStep.hidden = true;
      }

      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          if (tile.disabled) return;
          if (chosen.length >= total) {
            showError('Your rotation is full. Remove one to swap it out.');
            return;
          }
          showError('');
          openSizeStep(tile);
        });
      });

      if (sizeCancel) sizeCancel.addEventListener('click', closeSizeStep);

      slots.forEach(function (slot, i) {
        var clear = slot.querySelector('[data-od-bundle-clear]');
        var name = slot.querySelector('[data-od-bundle-slot-name]');
        if (name) name.setAttribute('data-empty', name.textContent);
        if (!clear) return;
        clear.addEventListener('click', function () {
          chosen.splice(i, 1);
          showError('');
          render();
        });
      });

      if (addBtn) addBtn.addEventListener('click', function () {
        if (chosen.length < total) return;
        addBtn.disabled = true;
        showError('');

        var items = chosen.map(function (c) {
          var props = {};
          if (property) props['Bundle'] = property;
          if (c.useProperty) props['Size'] = c.size;
          if (c.useProperty && c.fit) props['Fit'] = c.fit;
          var item = { id: c.variantId, quantity: 1 };
          if (Object.keys(props).length) item.properties = props;
          return item;
        });

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            return r.json().then(function (body) {
              if (!r.ok) throw new Error(body && body.description ? body.description : 'Could not add to bag.');
              return body;
            });
          })
          .then(function () {
            chosen = [];
            closeSizeStep();
            render();
            flashButton(addBtn, addedText);
            if (typeof readCartCount === 'function') readCartCount();
            addBtn.disabled = true;
          })
          .catch(function (err) {
            addBtn.disabled = false;
            showError(err && err.message ? err.message : 'Could not add to bag. Try again.');
          });
      });

      render();
    });
  }

  /* ---------- email popup ----------
     Never on load. Whichever trigger fires first wins, and a dismissal or a
     signup is remembered so the same person is not asked again. */

  function initPopup() {
    var popup = document.querySelector('[data-od-popup]');
    if (!popup || !once(popup)) return;

    var KEY = 'od-popup';
    var days = parseInt(popup.getAttribute('data-remember'), 10) || 30;
    var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 0) * 1000;
    var depth = parseInt(popup.getAttribute('data-scroll'), 10) || 0;
    var exitOn = popup.getAttribute('data-exit') === 'true';

    function seen() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return false;
        var s = JSON.parse(raw);
        if (s.joined) return true;                       // signed up: never again
        return Date.now() - (s.at || 0) < days * 86400000;
      } catch (e) { return false; }
    }
    function remember(joined) {
      try { localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), joined: !!joined })); } catch (e) {}
    }

    // Shopify reloads the page after the form posts, and both this form and the
    // footer signup come back with the same customer_posted flag. The marker set
    // at submit time is what tells them apart, so a footer signup never pops this
    // open and a popup signup still gets its confirmation.
    var SUBMITTED = 'od-popup-submitted';
    var justSubmitted = false;
    try {
      justSubmitted = sessionStorage.getItem(SUBMITTED) === '1';
      if (justSubmitted) sessionStorage.removeItem(SUBMITTED);
    } catch (e) {}

    var posted = /customer_posted=true/.test(location.search);
    if (posted && justSubmitted) {
      remember(true);
      popup.hidden = false;
      popup.querySelectorAll('[data-od-popup-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { popup.hidden = true; });
      });
      return;
    }
    if (posted) remember(true);

    if (seen()) return;

    var opened = false;
    var timers = [];

    function open() {
      if (opened || seen()) return;
      opened = true;
      timers.forEach(clearTimeout);
      popup.hidden = false;
      document.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExit);
      var field = popup.querySelector('input[type="email"]');
      if (field) { try { field.focus({ preventScroll: true }); } catch (e) {} }
    }

    function close() {
      popup.hidden = true;
      remember(false);
    }

    function onScroll() {
      if (!depth) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return;
      if ((window.pageYOffset / h) * 100 >= depth) open();
    }

    function onExit(e) {
      if (e.relatedTarget || e.toElement) return;   // moving inside the page
      if (e.clientY > 12) return;                   // only toward the tab bar
      open();
    }

    if (delay > 0) timers.push(window.setTimeout(open, delay));
    if (depth > 0) document.addEventListener('scroll', onScroll, { passive: true });
    if (exitOn) document.addEventListener('mouseout', onExit);

    popup.querySelectorAll('[data-od-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) close();
    });

    var form = popup.querySelector('form');
    if (form) form.addEventListener('submit', function () {
      remember(true);
      try { sessionStorage.setItem(SUBMITTED, '1'); } catch (e) {}
    });
  }

  /* ---------- Statement Collection ----------
     Two small jobs, no library:

       flip     the front/back toggle. Hover does this on a mouse in CSS; this
                is the touch and keyboard route, without which a phone could
                never reach the back of the shirt.
       reveal   a one-shot fade-up as cards enter the viewport. The observer
                releases each element once it has fired, so nothing keeps
                watching the page after the work is done. Honours
                prefers-reduced-motion by simply showing everything.
  */

  function initStatement() {
    document.querySelectorAll('[data-od-flip-btn]').forEach(function (btn) {
      if (!once(btn)) return;
      var card = btn.closest('.od-stmt__card');
      var media = card && card.querySelector('[data-od-flip]');
      if (!media) return;

      btn.addEventListener('click', function () {
        var on = media.getAttribute('data-flipped') === 'true';
        media.setAttribute('data-flipped', on ? 'false' : 'true');
        btn.setAttribute('aria-pressed', on ? 'false' : 'true');
      });
    });

    var targets = document.querySelectorAll('.od-stmt__reveal:not(.is-in)');
    if (!targets.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);          // done with this one for good
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el) { io.observe(el); });

    /* Belt and braces: anything still hidden two seconds after load is shown,
       whatever the observer did or did not do. */
    window.setTimeout(function () {
      document.querySelectorAll('.od-stmt__reveal:not(.is-in)').forEach(function (el) {
        el.classList.add('is-in');
      });
    }, 2000);
  }

  function boot() {
    // first, and wrapped, so nothing later can prevent the cards appearing
    try { initStatement(); } catch (e) {}

    document.querySelectorAll('[data-od-product]').forEach(function (root) {
      initProduct(root);
      initGallery(root);
    });
    document.querySelectorAll('[data-od-product]').forEach(initOptionLabels);
    initAccordions();
    initAudio();
    initSongBar();
    initFilm();
    initSoftNav();
    initQuantity();
    initNotify();
    initPolicy();
    initCart();
    initSort();
    initAddresses();
    initAnnounce();
    initAnchors();
    initBundle();
    initPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: a section can be re-rendered at any moment. Re-run setup for
     the new markup, but sweep away anything that would give us a second copy
     of the song first. */
  ['shopify:section:load', 'shopify:section:reorder', 'shopify:block:select'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      purgeStrayAudio(document.querySelector('#MainContent') || document.querySelector('main'));
      boot();
    });
  });
  document.addEventListener('shopify:section:unload', function () {
    purgeStrayAudio(document.querySelector('#MainContent') || document.querySelector('main'));
  });
})();
